import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const PlanCtx = createContext(null);
export const usePlan = () => useContext(PlanCtx);

export function PlanProvider({ children }) {
  const { user } = useAuth();
  const [plan, setPlan] = useState(null); // null = loading

  const refreshPlan = useCallback(async () => {
    try {
      const { data } = await api.get("/billing/me");
      setPlan(data);
    } catch {
      setPlan({ pro: false, scansLeft: 0, plans: {} });
    }
  }, []);

  useEffect(() => {
    if (user === null) return;
    refreshPlan();
  }, [user, refreshPlan]);

  const startCheckout = async (lookupKey) => {
    const { data } = await api.post("/billing/checkout", { lookup_key: lookupKey, origin_url: window.location.origin });
    window.location.href = data.checkout_url;
  };
  const openPortal = async () => {
    const { data } = await api.post("/billing/portal", { origin_url: window.location.origin });
    window.location.href = data.url;
  };

  return (
    <PlanCtx.Provider value={{ plan, pro: !!plan?.pro, refreshPlan, startCheckout, openPortal }}>
      {children}
    </PlanCtx.Provider>
  );
}
